import { render, staticRenderFns } from "./BillIcon5.vue?vue&type=template&id=9838dcd0&"
import script from "./BillIcon5.vue?vue&type=script&lang=ts&"
export * from "./BillIcon5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports